export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=404b5af15f0a66300fbbc890a6d281ef2b4724bf56&name=revalidateCommunity!'